'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/ClipArtSkin.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const ClipArtSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const ClipArt: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={ClipArtSkin} />
);

export default ClipArt;
